module.exports = __webpack_public_path__ + "img/product_icon.cfda9368.png";